import baseApi from "./baseApi";
import axios from "axios";



const getTransactions = () => axios.get("Wallet/WalletTransaction", { headers: { 'Authorization': 'Bearer ' + baseApi.getToken() } });


export default {
    getTransactions
};